import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { FiChevronDown, FiMenu, FiHelpCircle } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { isAdmin, isTrial, getTrialDays } from "utils/utils";
import Avatar from "components/Avatar";
import Sidebar from "./Sidebar";
import Logo from "components/Logo";
import { authService } from "services";
import { getAppName, getHelpUrl } from "utils/utils";
import {
	bootIntercom,
	updateIntercom,
	shutdownIntercom,
} from "utils/intercomUtils";
import { isHaddockEnvironment } from "utils/documentUtils";

const Header = (props) => {
	const { t } = useTranslation();
	const { user } = props;
	var days;

	// console.log(user);

	const appName = getAppName();
	const helpUrl = getHelpUrl();

	useEffect(() => {
		bootIntercom(user);
	}, [user]);

	// window.Intercom('boot', {
	// 	app_id: 'nzk8tbj7',
	// 	user_id: user.id,
	// 	email: user.email,
	// 	name: user.name,
	// 	rol: user.position,
	// });

	// console.log(user.subscription);

	if (isTrial()) {
		const totalDays = getTrialDays();
		// console.log(totalDays);

		if (totalDays == 0) {
			days = t("header.trial.lastDay", { appName });
		} else if (totalDays < 0) {
			days = t("header.trial.expired", { appName });
		} else {
			days = t("header.trial.daysLeft", { count: totalDays, appName });
		}
	}

	const handleLogout = () => {
		shutdownIntercom();
		authService.logout();
	};

	return (
		<>
			{isTrial() && (
				<div className="header-trial">
					{days}

					{!isHaddockEnvironment() && (
						<Link to="/contract-plans" className="btn btn-primary">
							{t("header.subscribeNow")}
						</Link>
					)}
				</div>
			)}
			<header className="header">
				<div className="header-container">
					<div className="header-main">
						<button
							type="button"
							title="Menu"
							onClick={props.toggleNav}
							className="btn btn-transparent btn-menu"
						>
							<FiMenu />
						</button>

						<Link className="header-logo-link" to="/">
							<Logo className="header-logo" type="logo" />
							<Logo className="header-iso" type="iso" />
						</Link>
					</div>

					<div className="header-right">
						<a
							className="link-help"
							title={t("header.help")}
							rel="noopener noreferrer"
							target="_blank"
							href={helpUrl}
						>
							<FiHelpCircle className="icon-help" />
						</a>

						<div className="header-menu">
							<div className="header-menu-profile">
								<Avatar
									userId={user.id}
									className="header-avatar avatar-xs"
									alt={user.name}
								/>
								<span className="header-username">
									{user.name} {user.surname}
								</span>{" "}
								<FiChevronDown className="header-dropdown-arrow" />
							</div>
							<ul>
								<li className="option-profile">
									<Link className="header-menu-item" to="/profile">
										{t("profile.profile")}
									</Link>
								</li>
								{isAdmin() && (
									<>
										<li className="option-company">
											<Link className="header-menu-item" to="/my-company">
												{t("profile.myCompany")}
											</Link>
										</li>
										{/* <li className="option-subscription">
											<Link className="header-menu-item" to="/my-subscription">
												Mi suscripción
											</Link>
										</li> */}
									</>
								)}
								<li className="option-logout">
									<button
										className="header-menu-item button-link"
										onClick={handleLogout}
									>
										{t("profile.logout")}
									</button>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</header>
			{props.isMobileNavVisible && (
				<>
					<Sidebar className="mobile-sidebar" handleClose={props.closeNav} />
					<div className="mobile-sidebar-overlay" onClick={props.closeNav} />
				</>
			)}
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		user: state.authReducer.user,
	};
};

// export default Header;
export default connect(mapStateToProps, null)(withRouter(Header));
